var base = require('settings/security/disable-two-factor-auth');

Vue.component('spark-disable-two-factor-auth', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/settings/security/disable-two-factor-auth.js